const BUYER = 'buyer';
const SELLER = 'seller';

module.exports = {
    BUYER,
    SELLER
}